import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {CreateSubscriptionPage} from './pages/CreateSubscriptionPage';
import {ConfirmSubscriptionPage} from './pages/ConfirmSubscriptionPage';
import {IndexPage as PaymentMethodsPage} from '../payment-profiles';

export const StripeSubscriptionsLayout = () => {
    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/create'
                element={
                    allowedActions.includes(rbacActions.GetUserAccount) ? (
                        <CreateSubscriptionPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            
            <Route
                path='/confirm'
                element={
                    allowedActions.includes(rbacActions.GetUserAccount) ? (
                        <ConfirmSubscriptionPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            
            <Route
                path='/select-payment-method'
                element={
                    allowedActions.includes(rbacActions.GetUserAccount) ? (
                        <PaymentMethodsPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
        </Routes>
    );
};